export default __webpack_public_path__ + "static/media/ithiri2.af588e5c.png";